__turbopack_context__.v({
  "control": "ColorField-module__bRAdIW__control",
  "disabled": "ColorField-module__bRAdIW__disabled",
  "error": "ColorField-module__bRAdIW__error",
  "errorIcon": "ColorField-module__bRAdIW__errorIcon",
  "eyedropper": "ColorField-module__bRAdIW__eyedropper",
  "helper": "ColorField-module__bRAdIW__helper",
  "hex": "ColorField-module__bRAdIW__hex",
  "hue": "ColorField-module__bRAdIW__hue",
  "invalid": "ColorField-module__bRAdIW__invalid",
  "label": "ColorField-module__bRAdIW__label",
  "picker": "ColorField-module__bRAdIW__picker",
  "pickerAbove": "ColorField-module__bRAdIW__pickerAbove",
  "revert": "ColorField-module__bRAdIW__revert",
  "root": "ColorField-module__bRAdIW__root",
  "saturation": "ColorField-module__bRAdIW__saturation",
  "saturationMarker": "ColorField-module__bRAdIW__saturationMarker",
  "swatch": "ColorField-module__bRAdIW__swatch",
  "swatchEmpty": "ColorField-module__bRAdIW__swatchEmpty",
  "swatchWrapper": "ColorField-module__bRAdIW__swatchWrapper",
});
